/**
 * @file reportWebVitals.ts
 * @brief Misst und meldet Web Vitals für die Leistungsüberwachung der Anwendung.
 *
 * Diese Funktion importiert dynamisch die 'web-vitals'-Bibliothek und ruft die
 * verschiedenen Web Vitals-Messfunktionen auf, um Leistungsdaten zu sammeln.
 *
 * @param {ReportCallback} [onPerfEntry] - Eine optionale Callback-Funktion, die mit den
 * gemessenen Leistungsdaten aufgerufen wird. Nützlich für die Integration mit Analysediensten.
 * @returns {void}
 */
import { onCLS, onINP, onFCP, onLCP, onTTFB, ReportCallback } from 'web-vitals';

const reportWebVitals = (onPerfEntry?: ReportCallback) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry);
    onINP(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
